export enum TextEditorType {
  TextArea = 'textArea',
  TextField = 'textField',
  AlignedToRight = 'right',
  AlignedToLeft = 'left'
}